import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    unEditableFlag: false
}

const JobInfoSlice = createSlice({
    name: 'jobInfo',
    initialState,
    reducers: {
        getUnEditable(state, action) {
            state.unEditableFlag = action.payload;
        }
    }
});

export const { getUnEditable } = JobInfoSlice.actions;

export default JobInfoSlice.reducer;